export enum ProgressTrackingLevels {
  LevelP = 656,
  LevelOne = 657,
  LevelTwo = 658,
  LevelThree = 659,
}
